<template>
    <div>
        <v-row class="pb-3 justify-space-between">
            <v-col class="d-flex align-center">
                <h2 class="primary--text">Dados da compra</h2>
            </v-col>
        </v-row>
        <v-divider />
        <div class="mx-1 mt-3 mb-5">
            <v-layout wrap>
                <v-flex v-if="pedido.id_documento" xs12 md6>
                    <label>Número da proposta</label>
                    <p>{{ pedido.id_documento }}</p>
                </v-flex>
                <v-flex xs12 md6>
                    <label>Nome do bem</label>
                    <p>{{ (pedido.bem.cd_bem ? pedido.bem.cd_bem : "") + " - " + pedido.bem.nome_bem }}</p>
                </v-flex>
                <v-flex xs12 md6>
                    <label>Valor do bem</label>
                    <p>{{ pedido.bem.valor_bem || 0 | money }}</p>
                </v-flex>
                <v-flex v-if="desconto" xs12 md6>
                    <label>Valor da primeira parcela com desconto</label>
                    <p>{{ pedido.bem.vl_c_desconto || 0 | money }}</p>
                </v-flex>
                <v-flex v-if="desconto" xs12 md6>
                    <label>Valor original da primeira parcela</label>
                    <p>{{ pedido.bem.vl_original || 0 | money }}</p>
                </v-flex>
                <v-flex xs12 md6>
                    <label>Plano</label>
                    <p>{{ (pedido.plano.cd_plano_venda ? pedido.plano.cd_plano_venda : "") + " - " + (pedido.plano.nome_plano ? pedido.plano.nome_plano : "") }}</p>
                </v-flex>
                <v-flex xs12 md6>
                    <label>Prazo contratado</label>
                    <p>{{ pedido.plano.prazo_comercializacao }}</p>
                </v-flex>
                <v-flex xs12 md6>
                    <label>{{ labelCota }}</label>
                    <p>{{ definirLabel() }}</p>
                </v-flex>
                <v-flex xs12 md6 v-if="pedido.carrinho && pedido.carrinho.qt_cotas">
                    <label>Valor total</label>
                    <p>{{ pedido.bem.valor_bem * (pedido.carrinho.qt_cotas || 1) | money }}</p>
                </v-flex>
                <v-flex xs12 md6>
                    <label>Grupo</label>
                    <p>{{ trimZeros(pedido.bem.cd_grupo) || trimZeros(pedido.cd_grupo) || "-" }}</p>
                </v-flex>
                <v-flex xs12 md6>
                    <label>Negociação do pagamento do furo</label>
                    <p>{{ hasError ? "-" : getOpcaoFuro(pedido.opcao_furo, pedido.plano.situacao_grupo) }}</p>
                </v-flex>
                <v-flex xs12 md6 v-if="permiteFlavorTodosProdutos">
                    <label>Administrado por:</label>
                    <p>{{ administradora }}</p>
                </v-flex>
                <v-flex xs12 md6>
                    <label>Código da reserva</label>
                    <p>{{ pedido.id_reserva || "-" }}</p>
                </v-flex>
                <v-flex xs12 md6>
                    <label>Quantidade de parcelas furo</label>
                    <p>{{ hasError ? "-" : getParcelasFuro(pedido.qtd_parcela_furo, pedido.plano.situacao_grupo) }}</p>
                </v-flex>
                <v-flex xs12 md6 v-if="pedido.forma_pagamento === 'link'">
                    <label>Código do pagamento do cliente</label>
                    <p>{{ getTextCodigoPagamento(pedido.forma_pagamento, pedido.codigo_pagamento_cliente, pedido.data_validade) }}</p>
                </v-flex>
                <v-flex xs12 md6>
                    <label>Comissionado</label>
                    <p>{{ getComissionado }}</p>
                </v-flex>
                <v-flex xs12 md6>
                    <label>Filial</label>
                    <p>{{ (pedido.cd_filial ? pedido.cd_filial : "") + " - " + (pedido.nome_filial ? pedido.nome_filial : "") }}</p>
                </v-flex>
                <v-flex xs12 md6>
                    <label>Código produto</label>
                    <p>{{ pedido.produto.cd_produto }}</p>
                </v-flex>
                <v-flex xs12 md6 v-if="aguardandoPagamentoCliente">
                    <label>Link de pagamento</label>
                    <p class="link-text">{{ pedido.link_pagamento }}</p>
                </v-flex>
                <v-btn id="ButtonCopiarCodigo" color="secondary" v-if="aguardandoPagamentoCliente" @click="copiarLinkPagamento()" class="ml-1">
                    COPIAR LINK
                </v-btn>
                <v-flex xs12 md6 v-if="seguro.exibir">
                    <label
                    >Seguro Prestamista ({{
                        parseFloat(pedido.grupo.pe_seguro).toLocaleString("pt-BR", {
                            maximumFractionDigits: 20
                        })
                    }}% mensal)*</label
                    >
                    <v-radio-group id="GroupSeguro" ref="seguro_radio" :disabled="!isVendaNaoGerada(pedido.status_pedido)" @change="toggleSeguro()" v-model="pedido.seguro" :rules="[$rules.selected]" row>
                        <v-radio id="RadioSim" label="Sim" :value="true" />
                        <v-radio id="RadioNao" label="Não" :value="false" />
                    </v-radio-group>
                </v-flex>
            </v-layout>
        </div>
    </div>
</template>

  <script>
  import { isVendaNaoGerada, notification, trimZeros } from '../../plugins/helpers'
  import detalhesAndResumo from '../../mixins/detalhesAndResumo'
  import { getTextCodigoPagamento } from '../../plugins/textFormatters'
  import { AlertTypes } from '../../plugins/alerts_types'
  export default {
    name: 'DadosDaCompra',
    mixins: [ detalhesAndResumo ],
    props: {
      pedido: {
        type: Object,
        required: true
      },
      desconto: {
        type: Boolean,
        default: false
      },
      permiteFlavorTodosProdutos: {
        type: Boolean,
        default: false
      },
      administradora: {
        type: String,
        default: ''
      },
      seguro: {
        type: Object,
        default: () => ({ exibir: false })
      },
      aguardandoPagamentoCliente: {
        type: Boolean,
        default: false
      },
      hasError: {
        type: Boolean,
        default: false
      },
      labelCota: {
        type: String,
        default: 'Número da cota'
      }
    },
    computed: {
      getComissionado () {
        return (this.pedido.cd_comissionado ? this.pedido.cd_comissionado : '') + ' - ' + (this.pedido.nm_comissionado ? this.pedido.nm_comissionado : '') || '-'
      }
    },
    methods: {
      trimZeros,
      getTextCodigoPagamento,
      isVendaNaoGerada,
      copiarLinkPagamento () {
        const el = document.createElement('textarea')
        el.value = this.pedido.link_pagamento
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
        notification(AlertTypes.INFO, 'Link de pagamento copiado.')
      },
      toggleSeguro () {
        this.$emit('toggleSeguro')
      },
      definirLabel () {
        if (this.labelCota === 'Número da cota') {
          return this.pedido.cd_cota || '-'
        } else {
          return this.pedido.carrinho.qt_cotas || '1'
        }
      }
    }
  }
  </script>

  <style scoped>
label {
    font-size: 1rem;
    color: var(--darkgray);
}

p {
    color: var(--dark);
    font-size: 1.1rem;
}
.regular-label {
    font-size: 13px;
}

.link-text {
word-break: break-all;
}

  </style>
